import React from "react"
import { CircularProgress, styled } from '@mui/material'

const StyledProgress = styled(CircularProgress)(({ theme }) => ({
    color: theme.primary,
}))

export default () => {
    return (
        <StyledProgress />
    )
}
